import { Exception } from 'src/app/core/logic/exception';

export class CompositionNotFoundException extends Exception<never> {
  constructor() {
    super('Document libre non trouvé');
  }
}
